/* Defiant Attitude theme scripts: menu, search, variant picker, quantity, sort. */
document.addEventListener('DOMContentLoaded', function () {
  // Toggle panels (menu, search)
  document.querySelectorAll('[data-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('data-toggle'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      document.querySelectorAll('[data-panel]').forEach(function (p) { p.setAttribute('hidden', ''); });
      document.querySelectorAll('[data-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (open) {
        panel.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        var input = panel.querySelector('input');
        if (input) input.focus();
      }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-panel]').forEach(function (p) { p.setAttribute('hidden', ''); });
      document.querySelectorAll('[data-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '0', 10) + parseInt(b.getAttribute('data-step'), 10);
        var min = parseInt(input.getAttribute('min') || '0', 10);
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Sort select on collection pages
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Variant picker
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var data = JSON.parse(document.getElementById('product-json').textContent);
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add]');
    var priceEl = document.querySelector('[data-price]');
    var labels = form.querySelectorAll('[data-option-label]');
    function selected() {
      var opts = [];
      form.querySelectorAll('fieldset[data-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        opts.push(c ? c.value : null);
      });
      return opts;
    }
    function update() {
      var opts = selected();
      labels.forEach(function (l, i) { l.textContent = opts[i] || ''; });
      var v = data.variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (priceEl) priceEl.innerHTML = v.price_html;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('change', function (e) {
      if (e.target.closest('fieldset[data-option]')) update();
    });
  }
});
